<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.NATIONALITIES"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            :title="$t('monitoringPage.nationalities.pageTitle')"/>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "Nationalities",
        title() {
            return this.$t("monitoringPage.nationalities.pageTitle");
        },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("monitoringPage.common.name"),
                    "created_at": this.$t("monitoringPage.common.createdAt"),
                    "updated_at": this.$t("monitoringPage.common.updatedAt")
                }
            }
        }
    }
</script>

<style scoped>

</style>